import type { Plugins } from 'core/plugins/config/types';
import { buildErrorMsg } from 'core/plugins/model/build-error-message';
import { getMapOfLoadablePlugins } from 'core/plugins/model/get-map-of-loadable-plugins';

/**
 * Orders a list of plugins based on requires. If this fails an error is thrown.
 */
export function getPluginsOrderedByRequires(
  unsortedPlugins: Plugins.Model[],
  loadedPlugins: Plugins.Model[],
) {
  if (unsortedPlugins.length === 0) {
    return [];
  }

  const unsortedPluginsMap = new Map(unsortedPlugins.map((plugin) => [plugin.name, plugin]));
  const loadedPluginsMap = new Map(loadedPlugins.map((plugin) => [plugin.name, plugin]));
  const resultMap = getMapOfLoadablePlugins(unsortedPluginsMap, loadedPluginsMap);

  if (resultMap.size === 0) {
    const errorMsg = buildErrorMsg(unsortedPlugins);

    throw new Error(`Required plugins do not exist: ${errorMsg}`);
  }

  return [...resultMap.values()];
}
